export default {
  data() {
    return {
      optionApi: require('@/api/sy/opt').default,
      optionData: {},
    }
  },
  methods: {
    setNumber(data) {
      let str = data.toString();
      let chat = str[0];
      let reg = /^-?[0-9]*$/;
      if (!reg.test(chat)) {
        return 0
      } else {
        return parseFloat(data)
      }
    },
    callOptionApi() {
      return new Promise((resolve, reject) => {
        this.optionApi.list({ Code: "NumericSetting" }).then(res => { 
          const result = res.Data.reduce((acc, obj) => {
            const key = obj.OptText;
            var value
            if (obj.OptValue === 'true' || obj.OptValue === 'false') {
              value = obj.OptValue;
            } else {
              value = Number(obj.OptValue);
            }
            acc[key] = value;
            return acc;
          }, {});
          this.optionData = result;
          resolve(res);
        })
        //旧 玩具代码 因无数值选项页面 故弃用
        // this.optionApi.getNumericSetting().then(res => {
        //   if (res.Code === 0) {
        //     this.optionData = res.Data;
        //     resolve(res);
        //   }
        // })
      })
    },
    getAmount(val) {
      return this.toThousands(parseFloat(val.toFixed(2)));
    },
    //千位符 保留小数后两位
    toThousands(num) {
      let a = "";
      let b = "";
      let bool = false; // 是否有小数点
      let absBool = false;

      num = parseFloat(num);

      if (Number.isNaN(num)) { return null; }
      if (num && num < 0) {
        num = Math.abs(num);
        absBool = true;
      }

      if (num && num.toString().indexOf('.') !== -1) {
        bool = true;
        let numStr = num.toString()
        let arr = numStr.split('.')
        a = arr[0];
        b = arr[1];
        num = Number(a);
      }

      var num = (num || 0).toString(), result = '';
      // console.log('num===========', num)
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }

      if (num) { result = num + result; }
      if (bool) { result = result + '.' + b; }
      if (absBool) { result = '-' + result; }
      return result;
    },
    //有bug 当只有小数点1位时就有问题
    // getCapitalAmount(val) {
    //   console.log("val", val);
    //   var v = val.toString();
    //   var minus = "";
    //   //判断数据小于0
    //   if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(v)) {
    //     v = Math.abs(v).toString()
    //     minus = "（负）"; //如果是负数，加上负文字
    //   }

    //   var unit = "仟佰拾亿仟佰拾万仟佰拾元";
    //   var str = "";

    //   var indexpoint = v.indexOf("."); // 如果是小数，截取小数点前面的位数

    //   if (indexpoint >= 0) {
    //     v = v.substring(0, indexpoint) + v.substr(indexpoint + 1, 2); // 若为小数，截取需要使用的unit单位
    //     unit += "角分";
    //   }

    //   unit = unit.substr(unit.length - v.length); // 若为整数，截取需要使用的unit单位
    //   for (var i = 0; i < v.length; i++) {
    //     str += "零壹贰叁肆伍陆柒捌玖".charAt(v.charAt(i)) + unit.charAt(i); //遍历转化为大写的数字
    //   }
    //   console.log("str", str);
    //   return minus + str
    //     .replace(/零(仟|佰|拾|角)/g, "零")
    //     .replace(/(零)+/g, "零")
    //     .replace(/零(万|亿|元)/g, "$1")
    //     .replace(/(亿)万|(拾)/g, "$1$2")
    //     .replace(/^元零?|零分/g, "")
    //     .replace(/元$/g, "元整"); // 替换掉数字里面的零字符，得到结果
    // },
    getCapitalAmount(n) {
      if (!/^(0|\-*[1-9]\d*)(\.\d+)?$/.test(n)) return "";
    	var fuhao = (n.toString().indexOf("-")==0?"（负）":"");
        
      var unit = "千百拾亿千百拾万千百拾元角分", str = "";
      n += "00";
      //如果是负数就就截取
      if(fuhao == "（负）") n = n.substring(1, n.length);
      var p = n.indexOf('.');
      if (p >= 0) n = n.substring(0, p) + n.substr(p+1, 2);
      unit = unit.substr(unit.length - n.length);
      for (var i=0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
      return fuhao+str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    },
    // toPrice2(n) {
    //   if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    //     return ""; //判断数据是否大于0
    //   }

    //   var unit = "千百十亿千百十万千百十元角分",
    //     str = "";
    //   n += "00";

    //   var indexpoint = n.indexOf("."); // 如果是小数，截取小数点前面的位数

    //   if (indexpoint >= 0) {
    //     n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2); // 若为小数，截取需要使用的unit单位
    //   }

    //   unit = unit.substr(unit.length - n.length); // 若为整数，截取需要使用的unit单位
    //   for (var i = 0; i < n.length; i++) {
    //     str += "零一二三四五六七八九".charAt(n.charAt(i)) + unit.charAt(i); //遍历转化为大写的数字
    //   }
    //   console.log("str", str);
    //   return str
    //     .replace(/零(千|百|十|角)/g, "零")
    //     .replace(/(零)+/g, "零")
    //     .replace(/零(万|亿|元)/g, "$1")
    //     .replace(/(亿)万|(十)/g, "$1$2")
    //     .replace(/^元零?|零分/g, "")
    //     .replace(/元$/g, "元整"); // 替换掉数字里面的零字符，得到结果
    // },
    //数量
    getQuantity(val) {
      val = parseFloat(val)
      if (Number.isNaN(val)) { return null }
      return this.optionData.IsQuantityRounding ? parseFloat(val.toFixed(this.optionData.Quantity)) : val.toFixed(this.optionData.Quantity);
    },
    //换算率
    getIinvexchrate(rate) {
      if (rate.toString().indexOf('.') !== -1) {
        let valStr = rate.toString().split('.')[1];
        if (valStr.length > this.optionData.Iinvexchrate) {
          return Number(rate).toFixed(this.optionData.Iinvexchrate)
        } else {
          return rate;
        }
      } else {
        return rate;
      }
    },
    //单价
    getPrice(val) {
      let num = 0;
      let valStr = val.toString().split('.');

      let a = valStr[0];
      let _a = 0
      let b = valStr[1];
      let _b = 0;

      if (a.length > this.optionData.UnitPrice) {
        // this.$message({type: 'warning', message: `数值整数位超过${this.optionData.UnitPrice}位，已被截取`})
        _a = a.substr(0, this.optionData.UnitPrice);
      } else {
        _a = a;
      }

      if (b) {
        b = ('0.' + b) - 0
        _b = this.optionData.IsUnitPriceRounding ? parseFloat(Number(b).toFixed(this.optionData.UnitPriceDecimals)) : Number(b).toFixed(this.optionData.UnitPriceDecimals)
      }

      if (b) {
        _b = _b.toString().split('.')[1];

        num = Number(_a + '.' + _b);
      } else {

        num = Number(_a);
      }

      return num;
    },
  }
}